module.exports = __webpack_public_path__ + "img/got1.327df3ae.png";